import "core-js/es/array/at";
import "core-js/es/string/at";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { message, notification } from "antd";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider, CartProvider, ThemeProvider } from "./Context";
import { DEFAULT_STALE_TIME } from "./Constant";

message.config({
  maxCount: 1,
  duration: 2,
});

notification.config({
  maxCount: 1,
  duration: 2,
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: DEFAULT_STALE_TIME,
      gcTime: 10 * 60 * 1000,
      refetchOnWindowFocus: false,
      refetchOnReconnect: "always",
      retry: 1,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <AuthProvider>
          <CartProvider>
            <App />
          </CartProvider>
        </AuthProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
